'use client';

import Image from 'next/image';
import FeaturedIcon from '../../components/icons/FeaturedIcon';
import { Dropdown, MenuProps } from 'antd';
import { useRouter } from 'next/router';
import { useConnection, useUserInfo } from '../../connection/Application';
import { useMemo } from 'react';

type ProfileAvatarProps = {
  src: string;
  alt?: string;
  size?: number; // pixel size (default 160)
  showBadge?: boolean;
};

export default function ProfileAvatar({
  src,
  alt = 'Profile',
  size = 160,
  showBadge = true,
}: ProfileAvatarProps) {
  const history = useRouter();
  const user = useUserInfo();
  const role = user?.role;
  const connection = useConnection();
  const badgeSize = size * 0.3; // Badge is 30% of avatar size
  const badgeOffset = size * 0.03;
  const recruiterText = useMemo(
    () => (role && role.indexOf('recruiter') !== -1 ? 'Recruiter dashboard' : 'Become a recruiter'),
    [role],
  );
  const items: MenuProps['items'] = [
    {
      key: 'profile',
      label: 'My Profile',
      onClick: () => history.push(`/profile/${user?.userId}`),
    },
    {
      key: 'dashboard',
      label: 'My dashboard',
      onClick: () => history.push('/dashboard'),
    },
    {
      key: 'referrals',
      label: 'My Referrals',
      onClick: () => history.push(`/referrals/${user?.userId}`),
    },
    {
      key: 'recruiter',
      label: recruiterText,
      onClick: () =>
        history.push(recruiterText === 'Recruiter dashboard' ? '/recruiter' : '/guest-recruiter'),
    },
    { type: 'divider' },
    {
      key: 'sign-out',
      label: 'Sign out',
      onClick: () => {
        connection.setToken(undefined);
        history.replace('/');
      },
    },
  ];
  return (
    <Dropdown menu={{ items }} placement="bottom">
      <div className="relative inline-block cursor-pointer">
        <div
          className="relative rounded-full overflow-hidden bg-gray-200"
          style={{ width: size, height: size }}>
          <Image
            src={src}
            alt={alt}
            fill
            className=" rounded-full w-full h-full object-cover"
            priority
          />
        </div>
        {showBadge && (
          <div
            className="absolute flex items-center justify-center rounded-full bg-red-500"
            style={{
              width: badgeSize,
              height: badgeSize,
              bottom: badgeOffset,
              right: badgeOffset,
            }}>
            <FeaturedIcon
              className="text-white fill-white"
              style={{ width: badgeSize, height: badgeSize }}
            />
          </div>
        )}
      </div>
    </Dropdown>
  );
}
